import { type Websocket } from 'entities/WebSocket'

interface IEventInboxProps {
  id: number | string
}

export class ChannelInbox {
  privateChannelName?: string
  presenceChannelName?: string

  constructor(props: IEventInboxProps, private _websocket: Websocket) {
    if (props.id !== 0) {
      this.privateChannelName = `private-inbox.${props.id}`
      this.presenceChannelName = `presence-inbox.${props.id}`
      this.subscribe()
    }
  }

  subscribe() {
    this._websocket.subscribe(this.privateChannelName)
    this._websocket.subscribe(this.presenceChannelName)
  }

  unsubscribe() {
    if (this.privateChannelName) this._websocket.unsubscribe(this.privateChannelName)
    if (this.presenceChannelName) this._websocket.unsubscribe(this.presenceChannelName)
  }
}
